import { render } from "./LanguageMenu.vue?vue&type=template&id=5c563d74"
import script from "./LanguageMenu.vue?vue&type=script&lang=js"
export * from "./LanguageMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__